import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import { refreshQueue } from "@devowl-wp/real-queue";
import { observer } from "mobx-react";
import { Modal, Spin, Dropdown, App } from "antd";
import { __ } from "../../../../utils";
import { CodeMirror } from "../../..";
import wp from "wp";
const ScannerMarkupPopover = observer((param)=>{
    let { record } = param;
    const { message } = App.useApp();
    const [open, setOpen] = useState(false);
    const { data: { id }, markup, store } = record;
    const cmSettings = useMemo(()=>markup ? {
            ...window.cm_settings,
            codemirror: {
                ...wp.codeEditor.defaultSettings.codemirror,
                mode: markup.mime,
                lint: false,
                readOnly: true
            }
        } : {}, [
        markup
    ]);
    const toggleOpen = useCallback(()=>{
        if (open) {
            setOpen(false);
        } else {
            setOpen(true);
            store.fetchMarkup(id);
        }
    }, [
        open
    ]);
    const scanAgain = useCallback(async ()=>{
        store.addUrlsToQueue({
            urls: [
                record.data.sourceUrl
            ],
            purgeUnused: false
        });
        Promise.all([
            store.fetchResultExternals(),
            store.fetchResultTemplates(),
            refreshQueue()
        ]);
        message.info(__("Page is scheduled for scanning again..."));
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Modal, {
                title: __("Element found by markup"),
                open: open,
                width: 700,
                bodyStyle: {
                    paddingBottom: 0
                },
                okButtonProps: {
                    style: {
                        display: "none"
                    }
                },
                onCancel: toggleOpen,
                cancelText: __("Close"),
                children: /*#__PURE__*/ _jsx(Spin, {
                    spinning: !markup,
                    children: markup && /*#__PURE__*/ _jsx(CodeMirror, {
                        settings: cmSettings,
                        value: markup.markup
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Dropdown.Button, {
                onClick: toggleOpen,
                menu: {
                    items: [
                        {
                            key: "scan-again",
                            onClick: scanAgain,
                            label: __("Scan again")
                        }
                    ]
                },
                children: __("Open markup")
            })
        ]
    });
});
export { ScannerMarkupPopover };
